// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/envelop-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/lock-icon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-text-input {
  position: relative;
}
.custom-text-input:not(.hide-shadow) input,
.custom-text-input:not(.hide-shadow) select {
  box-shadow: 0px 1px 4px rgba(139, 138, 138, 0.1607843137);
}
.custom-text-input input,
.custom-text-input select {
  border-radius: 4px;
  border: 1px solid #ebebeb;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
  height: 36px;
}
.custom-text-input input::placeholder,
.custom-text-input select::placeholder {
  color: #a5a5a5;
  font-family: "Poppins";
  font-size: 12px;
  font-weight: 400;
}
.custom-text-input .input-icon-padding {
  padding-right: 2rem;
}
.custom-text-input select {
  padding-right: 30px !important;
}
.custom-text-input input[type=date] {
  padding-right: 12px !important;
}
.custom-text-input:not(.hide-default-icon) input {
  padding-left: 47px;
  padding-right: 47px;
}
.custom-text-input:not(.hide-default-icon) input::placeholder {
  color: #2e2e30;
}
.custom-text-input:not(.hide-default-icon) input[type=email] {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 20px center #fff;
}
.custom-text-input:not(.hide-default-icon) input[type=password] {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat 20px center #fff;
}
.custom-text-input textarea.form-control {
  min-height: 100px;
  resize: none;
  border: 1px solid #ebebeb;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
}
.custom-text-input textarea.form-control::placeholder {
  color: #a5a5a5;
  font-family: "Poppins";
  font-size: 12px;
  font-weight: 400;
}
.custom-text-input .input-icon {
  position: absolute;
  top: 50%; /* Position from the middle vertically */
  transform: translateY(-50%); /* Adjust for centering */
  right: 12px;
}

.app-switch-input.md {
  width: 40px !important;
  height: 18px !important;
  padding: 4px !important;
}
.app-switch-input.lg {
  width: 63px !important;
  height: 30px !important;
  padding: 4px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Input/Style.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AACQ;;EAEI,yDAAA;AACZ;AAEI;;EAEI,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gDAAA;EACA,YAAA;AAAR;AACQ;;EACI,cAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;AAEZ;AACI;EACI,mBAAA;AACR;AACI;EACI,8BAAA;AACR;AAEQ;EACI,8BAAA;AAAZ;AAIQ;EACI,kBAAA;EACA,mBAAA;AAFZ;AAGY;EACI,cAAA;AADhB;AAGY;EACI,8EAAA;AADhB;AAGY;EACI,8EAAA;AADhB;AAKI;EACI,iBAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gDAAA;AAHR;AAKQ;EACI,cAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;AAHZ;AAOI;EACI,kBAAA;EACA,QAAA,EAAA,wCAAA;EACA,2BAAA,EAAA,yBAAA;EACA,WAAA;AALR;;AAcI;EAGI,sBAAA;EACA,uBAAA;EACA,uBAAA;AAbR;AAeI;EACI,sBAAA;EACA,uBAAA;EACA,uBAAA;AAbR","sourcesContent":[".custom-text-input {\n    position: relative;\n    &:not(.hide-shadow) {\n        input,\n        select {\n            box-shadow: 0px 1px 4px #8b8a8a29;\n        }\n    }\n    input,\n    select {\n        border-radius: 4px;\n        border: 1px solid #ebebeb;\n        background: #fff;\n        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);\n        height: 36px;\n        &::placeholder {\n            color: #a5a5a5;\n            font-family: \"Poppins\";\n            font-size: 12px;\n            font-weight: 400;\n        }\n    }\n    .input-icon-padding {\n        padding-right: 2rem;\n    }\n    select {\n        padding-right: 30px !important;\n    }\n    input {\n        &[type=\"date\"] {\n            padding-right: 12px !important;\n        }\n    }\n    &:not(.hide-default-icon) {\n        input {\n            padding-left: 47px;\n            padding-right: 47px;\n            &::placeholder {\n                color: #2e2e30;\n            }\n            &[type=\"email\"] {\n                background: url(\"../../assets/images/envelop-icon.png\") no-repeat 20px center #fff;\n            }\n            &[type=\"password\"] {\n                background: url(\"../../assets/images/lock-icon.png\") no-repeat 20px center #fff;\n            }\n        }\n    }\n    textarea.form-control {\n        min-height: 100px;\n        resize: none;\n        border: 1px solid #ebebeb;\n        background: #fff;\n        border-radius: 4px;\n        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);\n\n        &::placeholder {\n            color: #a5a5a5;\n            font-family: \"Poppins\";\n            font-size: 12px;\n            font-weight: 400;\n        }\n    }\n\n    .input-icon {\n        position: absolute;\n        top: 50%; /* Position from the middle vertically */\n        transform: translateY(-50%); /* Adjust for centering */\n        right: 12px;\n    }\n}\n\n.app-switch-input {\n    &.sm {\n        // Write as per need\n    }\n\n    &.md {\n        // Write as per need\n\n        width: 40px !important;\n        height: 18px !important;\n        padding: 4px !important;\n    }\n    &.lg {\n        width: 63px !important;\n        height: 30px !important;\n        padding: 4px !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
